// extracted by mini-css-extract-plugin
module.exports = {"TEIDLogo":"TEIDLogo_TEIDLogo__gvxHV","Link":"TEIDLogo_Link__1sF5U"};